import { NotificationTypes, SafeAny } from '@/common/types';
import { ReportData } from '@/modules/report/types';
import { axiosInstance, i18n } from '@/common/utils';

export const getReport = async (
  { rootState, state, commit }: SafeAny,
  payload: { sleepStudyID: string; scoreSet: string }
) => {
  const locale = i18n.global.locale.value;
  const url = `${rootState.env.requestUrl.reports}/studies/${payload.sleepStudyID}/preview-report?locale=${locale}`;

  state.reportData.isLoading = true;
  state.reportData.error = undefined;

  try {
    const response = await axiosInstance.get<ReportData>(url);
    state.reportData.isLoading = false;
    state.reportData.data = response.data;
  } catch (error: SafeAny) {
    state.reportData.isLoading = false;
    state.reportData.data = undefined;
    commit(
      'addNotification',
      {
        i18nTitle: 'errorGetReport',
        i18nDescription: error.message,
        type: NotificationTypes.Error
      },
      { root: true }
    );
  }
};
